define( [
	"../Data"
], function( Data ) {
	return new Data();
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/data/var/dataPriv.js
 ** module id = 841
 ** module chunks = 2
 **/